var __rspack_ns_object = JSON.parse('{"rE":"3.14.0-beta.23"}')